import React from 'react'
import {components} from 'react-select'
import get from 'lodash/get'

const SelectInput = props => <components.Input {...props} type={get(props, 'selectProps.type')} />

export default SelectInput
